/**
 * Returns `url` only if it uses an http(s) scheme; otherwise null.
 *
 * Property/media values are stored data that can be attacker-influenced (e.g. via imports),
 * so rendering them straight into `href`/`src` is an XSS vector (`javascript:`, `data:`). Use
 * this to gate links/images and fall back to plain text when the scheme isn't safe.
 */
export const safeHttpUrl = (url: unknown): string | null => {
  if (typeof url !== "string" || url.length === 0) return null;
  try {
    const { protocol } = new URL(url, window.location.origin);
    return protocol === "http:" || protocol === "https:" ? url : null;
  } catch {
    return null;
  }
};
